/* eslint-disable import/prefer-default-export */

/* import { dateToLocalISO, differenceBetweenDays } from '../../components/epg-info/helpers'; */

import { standardizeStreamObject } from "../asset";
import { videocietyApi } from "../apis";

export function getVCStream(asset) {
  return videocietyApi.getTrailer(asset.id).then((trailerResponse) => {
    const { stream } = standardizeStreamObject(
      trailerResponse.data.Trailer.FullUrl.replace('http://', 'https://'),
      'application/dash+xml'
    );
    return { ...asset, stream };
  });
}

export function getVCAssetTitle(asset) {
  return asset.nameOriginal || asset.name || "";
}
